import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts(
  'profiles',
  'edit-patient-emergency-contact',
);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'patient_profiles',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/profiles/edit-patient-emergency-contact.js